/* EVERLINOR — interacciones propias (sin librerías) */
(function () {
  'use strict';
  /* Este archivo se incluye desde varias secciones: solo se inicia una vez
     (si no, cada copia añade el producto a la cesta y se duplican unidades). */
  if (window.__evScriptsLoaded) return;
  window.__evScriptsLoaded = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Aparición al hacer scroll ---------- */
  function initReveal(root) {
    var els = (root || document).querySelectorAll('.ev-reveal:not(.ev-visible), .ev-line-draw:not(.ev-visible)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('ev-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('ev-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Carrusel de portada ---------- */
  function initHero(root) {
    (root || document).querySelectorAll('[data-ev-hero]').forEach(function (hero) {
      if (hero.dataset.ready) return;
      hero.dataset.ready = '1';
      var track = hero.querySelector('.ev-hero__track');
      var slides = hero.querySelectorAll('.ev-hero__slide');
      var dots = hero.querySelectorAll('.ev-hero__dot');
      var count = hero.querySelector('[data-ev-count]');
      var total = slides.length;
      var i = 0, timer = null;
      var secs = parseInt(hero.dataset.autoplay || '0', 10);
      if (!track || total === 0) return;

      function go(n) {
        i = (n + total) % total;
        track.style.transform = 'translateX(' + (-100 * i) + '%)';
        slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); s.setAttribute('aria-hidden', k === i ? 'false' : 'true'); });
        dots.forEach(function (d, k) {
          d.classList.remove('is-active'); void d.offsetWidth;
          if (k === i) d.classList.add('is-active');
          d.setAttribute('aria-current', k === i ? 'true' : 'false');
        });
        if (count) count.textContent = String(i + 1).padStart(2, '0') + ' / ' + String(total).padStart(2, '0');
        restart();
      }
      function restart() {
        clearInterval(timer);
        if (secs > 0 && total > 1 && !hero.classList.contains('is-paused')) timer = setInterval(function () { go(i + 1); }, secs * 1000);
      }
      hero.querySelectorAll('[data-ev-prev]').forEach(function (b) { b.addEventListener('click', function () { go(i - 1); }); });
      hero.querySelectorAll('[data-ev-next]').forEach(function (b) { b.addEventListener('click', function () { go(i + 1); }); });
      dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); }); });
      /* Pasa solo siempre (también con el ratón encima); solo se para con la pestaña oculta */
      document.addEventListener('visibilitychange', function () { if (document.hidden) clearInterval(timer); else restart(); });

      /* Deslizar con el dedo / ratón */
      var startX = null, dx = 0;
      track.addEventListener('pointerdown', function (e) { startX = e.clientX; dx = 0; });
      track.addEventListener('pointermove', function (e) { if (startX !== null) dx = e.clientX - startX; });
      function end() {
        if (startX === null) return;
        if (Math.abs(dx) > 50) go(dx < 0 ? i + 1 : i - 1);
        startX = null; dx = 0;
      }
      track.addEventListener('pointerup', end);
      track.addEventListener('pointerleave', end);
      hero.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') go(i - 1);
        if (e.key === 'ArrowRight') go(i + 1);
      });
      go(0);
    });
  }

  /* ---------- Carruseles de productos (flechas) ---------- */
  function initRails(root) {
    (root || document).querySelectorAll('[data-ev-rail]').forEach(function (rail) {
      if (rail.dataset.ready) return;
      rail.dataset.ready = '1';
      var track = rail.querySelector('.ev-rail__track');
      if (!track) return;
      function step() { var c = track.firstElementChild; return c ? c.getBoundingClientRect().width + 20 : 300; }
      rail.querySelectorAll('[data-ev-rail-prev]').forEach(function (b) { b.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); }); });
      rail.querySelectorAll('[data-ev-rail-next]').forEach(function (b) { b.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); }); });
    });
  }

  /* ---------- Añadir a la cesta (abre el carrito lateral de Dawn) ---------- */
  function addToCart(variantId, qty, btn, onError) {
    if (btn && btn.getAttribute('aria-disabled') === 'true') return Promise.resolve();
    var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    var fd = new FormData();
    fd.append('id', variantId);
    fd.append('quantity', qty || 1);
    if (cart && typeof cart.getSectionsToRender === 'function') {
      fd.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }));
      fd.append('sections_url', window.location.pathname);
      if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
    }
    if (btn) btn.setAttribute('aria-disabled', 'true');
    var url = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add';
    return fetch(url, { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' }, body: fd })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) { if (onError) onError(res.description || res.message); return; }
        if (!cart) { window.location = window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart'; return; }
        if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
        cart.renderContents(res);
        if (btn) {
          var txt = btn.hasAttribute('data-ev-quick-add') ? btn.textContent : null;
          btn.classList.add('is-added');
          if (txt) btn.textContent = 'Añadido ✓';
          setTimeout(function () { btn.classList.remove('is-added'); if (txt) btn.textContent = txt; }, 1800);
        }
      })
      .catch(function () { if (onError) onError('No se ha podido añadir. Inténtalo de nuevo.'); })
      .finally(function () { if (btn) btn.removeAttribute('aria-disabled'); });
  }

  function initQuickAdd() {
    /* Enlace "Leer descripción completa": abre el desplegable y baja hasta él */
    document.addEventListener('click', function (e) {
      var more = e.target.closest('[data-ev-more]');
      if (!more) return;
      var det = document.getElementById('ev-descripcion');
      if (!det) return;
      e.preventDefault();
      det.open = true;
      det.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    });
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-ev-quick-add]');
      if (!btn) return;
      e.preventDefault();
      var original = btn.textContent;
      addToCart(btn.dataset.evQuickAdd, 1, btn, function () { btn.textContent = 'Agotado'; setTimeout(function () { btn.textContent = original; }, 2000); });
    });
  }

  /* ---------- Página de producto ---------- */
  function initProduct(root) {
    (root || document).querySelectorAll('[data-ev-pdp]').forEach(function (pdp) {
      if (pdp.dataset.ready) return;
      pdp.dataset.ready = '1';

      /* Galería */
      var imgs = pdp.querySelectorAll('.ev-pdp__main img');
      var thumbs = pdp.querySelectorAll('.ev-pdp__thumb');
      var cur = 0;
      function show(n) {
        if (!imgs.length) return;
        cur = (n + imgs.length) % imgs.length;
        imgs.forEach(function (im, k) { im.classList.toggle('is-active', k === cur); });
        thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === cur); });
        var t = thumbs[cur];
        if (t && t.parentElement) {
          var p = t.parentElement;
          if (p.scrollWidth > p.clientWidth) p.scrollTo({ left: t.offsetLeft - 20, behavior: 'smooth' });
        }
      }
      thumbs.forEach(function (t, k) { t.addEventListener('click', function () { show(k); }); });
      var prev = pdp.querySelector('[data-ev-gal-prev]');
      var next = pdp.querySelector('[data-ev-gal-next]');
      if (prev) prev.addEventListener('click', function () { show(cur - 1); });
      if (next) next.addEventListener('click', function () { show(cur + 1); });
      var main = pdp.querySelector('.ev-pdp__main');
      if (main) {
        var sx = null;
        main.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
        main.addEventListener('touchend', function (e) {
          if (sx === null) return;
          var d = e.changedTouches[0].clientX - sx;
          if (Math.abs(d) > 40) show(d < 0 ? cur + 1 : cur - 1);
          sx = null;
        });
      }

      /* Cantidad */
      var qty = pdp.querySelector('[data-ev-qty]');
      pdp.querySelectorAll('[data-ev-qty-btn]').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = parseInt(qty.value || '1', 10) + parseInt(b.dataset.evQtyBtn, 10);
          qty.value = Math.max(1, v);
        });
      });

      /* Variantes */
      var scope = pdp.parentElement || pdp;
      var form = pdp.querySelector('.ev-pdp__form');
      var idInput = form ? form.querySelector('input[name="id"]') : null;
      var btn = pdp.querySelector('[data-ev-add]');
      var btnLabel = btn ? btn.querySelector('[data-ev-add-label]') : null;
      var priceEl = pdp.querySelector('[data-ev-price]');
      var compareEl = pdp.querySelector('[data-ev-compare]');
      var stockEl = pdp.querySelector('[data-ev-stock]');
      var errEl = pdp.querySelector('[data-ev-error]');
      var dataEl = scope.querySelector('[data-ev-variants]');
      var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
      var selects = pdp.querySelectorAll('[data-ev-option]');
      var fmt = function (cents) {
        try { return new Intl.NumberFormat(document.documentElement.lang || 'es', { style: 'currency', currency: pdp.dataset.currency || 'EUR' }).format(cents / 100); }
        catch (e) { return (cents / 100).toFixed(2) + ' €'; }
      };
      function onChange() {
        var chosen = Array.prototype.map.call(selects, function (s) { return s.value; });
        var v = variants.find(function (x) { return x.options.every(function (o, k) { return o === chosen[k]; }); });
        if (!v) return;
        idInput.value = v.id;
        if (priceEl) priceEl.textContent = fmt(v.price);
        if (compareEl) { compareEl.textContent = v.compare_at_price > v.price ? fmt(v.compare_at_price) : ''; }
        if (btn) { if (v.available) btn.removeAttribute('disabled'); else btn.setAttribute('disabled', 'disabled'); }
        if (btnLabel) btnLabel.textContent = v.available ? pdp.dataset.addLabel : pdp.dataset.soldLabel;
        if (stockEl) { stockEl.classList.toggle('is-out', !v.available); stockEl.textContent = v.available ? pdp.dataset.inStock : pdp.dataset.outStock; }
        if (v.featured_media) {
          var idx = Array.prototype.findIndex.call(imgs, function (im) { return im.dataset.mediaId == v.featured_media.id; });
          if (idx > -1) show(idx);
        }
        var url = new URL(window.location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url);
      }
      selects.forEach(function (s) { s.addEventListener('change', onChange); });

      if (form) {
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          if (errEl) errEl.textContent = '';
          addToCart(idInput.value, qty ? qty.value : 1, btn, function (msg) { if (errEl) errEl.textContent = msg; });
        });
      }

      /* Barra de compra fija en móvil */
      var sticky = scope.querySelector('[data-ev-sticky]');
      if (sticky && btn && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (en) {
          var e = en[0];
          sticky.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
        }).observe(btn);
        var sb = sticky.querySelector('button');
        if (sb) sb.addEventListener('click', function () {
          addToCart(idInput.value, qty ? qty.value : 1, sb, function (msg) { if (errEl) errEl.textContent = msg; });
        });
      }
    });
  }

  /* ---------- Reseñas (Trustoo): colocarlas justo debajo del producto ---------- */
  function initReviews() {
    var slot = document.querySelector('[data-ev-reviews-slot]');
    if (!slot) return;
    function move() {
      var w = document.getElementById('trustoo-widget-wrapper');
      if (w && w.parentElement !== slot) { slot.appendChild(w); return true; }
      return !!w;
    }
    if (move() || !('MutationObserver' in window)) return;
    var mo = new MutationObserver(function () { if (move()) mo.disconnect(); });
    mo.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); }, 20000);
  }

  function initAll(root) {
    initReveal(root); initHero(root); initRails(root); initProduct(root); initReviews();
  }

  document.addEventListener('DOMContentLoaded', function () { initAll(document); initQuickAdd(); });
  /* Editor de Shopify: re-iniciar al editar secciones */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
